import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SolicitudAtestFitoResumenViewModel } from './resumen-list.types';

@Injectable()
export class ResumenAtestFitoService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    getSolicitudResumenAtestFito(id: number): Observable<SolicitudAtestFitoResumenViewModel> {
        return this.http.get<SolicitudAtestFitoResumenViewModel>(this.baseUrl + 'api/exportacion/atestaciones/resumenatest/' + id).pipe();
    }
}
